import { type Option } from "src/@types/common";

export const toOptions = (
  labelByType: Record<string, string>,
  sorted = true
): Option[] => {
  const options = Object.keys(labelByType).map((key) => ({
    label: labelByType[key],
    value: key,
  }));

  if (sorted) {
    return options.sort((a, b) => a.label.localeCompare(b.label));
  }

  return options;
};
